import AWS from 'aws-sdk';
import { log, getStackTrace } from "@src/Log.init";

// to-do: move the following variables to ENV
var imageBucketName = "mist-tenant-images";
var bucketRegion = "us-east-2";
var IdentityPoolId = "us-east-2:16825886-7ffd-454c-a604-885b835597ff";

AWS.config.update({
  region: bucketRegion,
  credentials: new AWS.CognitoIdentityCredentials({
    IdentityPoolId: IdentityPoolId
  })
});

var s3 = new AWS.S3({
  apiVersion: "2006-03-01",
  params: { Bucket: imageBucketName }
});

export const uploadImageFile = async (containerName, file) => {
  if (!file) return "";
  
  var upload = new AWS.S3.ManagedUpload({
    params: {
      Bucket: imageBucketName,
      Key: containerName + '/' + file.name,
      Body: file
    }
  });

  var imageURL = "";

  await upload.promise()
    .then(
      function(data) {
        imageURL = data.Location;
      },
      function(err) {
        log.error({message_type: "SystemError", message: `There was an error uploading your photo: ${err.message})`, meta_data: getStackTrace()});
      }
    );

  return imageURL;
};

export default uploadImageFile;